<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsSample-fabric',
  components: { PageTable },
}
</script>
